import {Price, toFarsiNumber} from "../tools/helpers";

const ListItem = ({title,isGreen,className, value,isPrice,isPercent,priceUnit='ریال'}) => {
    if (value === "" || !value) return <></>
    return <li className={`text-sm justify-between flex items-center bill-item  p-3 `}><span>{title}  </span><div>
        <span dir="ltr"
              className={`font-light text-sm  text-right ${isGreen ? 'font-bold text-green-500 ' :''}`}>{isPrice? toFarsiNumber(Price(value)):value}</span>
        {isPrice && <span className={` mr-1 ${isGreen ? ' text-green-500 ' :''}`}>{priceUnit}</span>}
        {isPercent && <span className="">%</span>}
    </div>
    </li>
}
export default ListItem;